import { Group, Text } from "@mantine/core";
import { EntityClientAction, MultiDataMapForm } from "@mcurros2/microm";
import { IconAlertCircle, IconUserPin } from "@tabler/icons-react";
import { Personal } from "../Personal";
import { PersonalTiendas } from "./PersonalTiendas";

export const ACTGestionarTiendas: EntityClientAction = {
    name: 'ACTGestionarTiendas',
    label: 'Gestionar Tiendas',
    title: <Text fw={700}>Gestionar Tiendas</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['plti_brwGestionTiendas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as PersonalTiendas;
        parent.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';
        parent.parentKeys = { ...parent.parentKeys, ...{ c_personal_id: selectedKeys![0].c_personal_id } };

        const personal = new Personal(entity.API.client)
        personal.def.columns.c_personal_id.value = parent.def.columns.c_personal_id.value
        await personal.API.getData();

        const description = `Personal: ${personal.def.columns.vc_apellido.value + ', ' + personal.def.columns.vc_nombre.value}` as string;

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">{description}</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <MultiDataMapForm
                autoFocus
                formMode="edit"
                key={`mapa-ubicacion-tiendas-${entity.def.name}`}
                title="Gestionar Tiendas"
                dataMapView1={{
                    entity: parent,
                    viewName: parent.def.views.plti_brwGestionTiendasPersonal.name,
                    parentKeys: parent.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 9, longitudRecordIndex: 10,
                    tabLabel: "Tiendas",
                    tabIcon: IconUserPin,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%",
                }}

                mapHeight="50vh"
            />
        });

        return false;
    }
}